export default __webpack_public_path__ + "static/media/07_Jahzzar_-_Endeavour.bf533c44.mp3";